import {
  Card,
  Modal,
  SkeletonBodyText,
  SkeletonThumbnail,
  TextStyle,
  VideoThumbnail,
} from "@shopify/polaris";
import { useState } from "react";
import Br from "./Br";

// To show the Learn how section with video
const LearnHowSection = ({ loading }) => {
  const [openVideoModal, setOpenVideoModal] = useState(false);
    return (<></>);
  return (
    <div style={{ marginRight: "2%" }}>
      <Modal
        large
        open={openVideoModal}
        onClose={() => setOpenVideoModal(false)}
      >
        <Modal.Section>
          <div style={{ padding: "15px" }}>
            <iframe
              style={{ borderRadius: "10px" }}
              width="100%"
              height="400"
              src="https://www.youtube.com/embed/yqMHzb0AbT4"
            ></iframe>
          </div>
        </Modal.Section>
      </Modal>
      <Card title="">
        <div
          style={{
            padding: "15px",
            background: "#F5F6F8",
            display: "flex",
            justifyContent: "space-between",
            height: "85px",
          }}
        >
          <div
            style={{
              width: "80%",
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "15%",
                minWidth: "110px",
              }}
            >
              {!loading && (
                <div
                  style={{
                    width: "80%",
                    position: "relative",
                  }}
                >
                  <img
                    style={{
                      minHeight: "60px",
                      minWidth: "50px",
                      width: "100%",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenVideoModal(true);
                    }}
                    src="https://i3.ytimg.com/vi/yqMHzb0AbT4/maxresdefault.jpg"
                  />
                  <img
                    onClick={() => {
                      setOpenVideoModal(true);
                    }}
                    height="30"
                    width="30"
                    style={{
                      position: "absolute",
                      top: "25%",
                      left: "35%",
                      cursor: "pointer",
                    }}
                    src="../../Assets/icons/Play-outlined.svg"
                  ></img>
                </div>
              )}
              <Br height={5} />
              {loading && <SkeletonThumbnail size="medium" />}
            </div>
            <div
              style={{
                width: "65%",
              }}
            >
              <TextStyle variation="strong">Learn how does is work?</TextStyle>
              <p>
                <TextStyle variation="subdued">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit do
                  aliqua.
                </TextStyle>
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              alt=""
              width="40%"
              height="40%"
              src="../../Assets/icons/Play-filled.svg"
            />
            <span
              style={{
                minWidth: "100px",
                marginLeft: "5px",
              }}
            >
              <TextStyle variation="subdued">Learn how</TextStyle>
            </span>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LearnHowSection;
